module.exports = __webpack_public_path__ + "media/entities/1120-f61af8e8.png";